import { Badge, Card, TextStyle } from "@shopify/polaris";
import React from "react";

const ImportStats = ({ stats }) => {
  if (!stats) {
    return null;
  }

  const { last_30_days = {}, change_types = {}, error_types = {} } =
    stats || {};

  const StatCard = ({ title, value, subtitle, color = "base" }) => (
    <div style={{ flex: "1 1 300px", minWidth: "200px" }}>
      <Card sectioned>
        <div style={{ textAlign: "center" }}>
          <TextStyle variation="subdued">{title}</TextStyle>
          <div style={{ margin: "8px 0" }}>
            <h1
              style={{
                fontSize: "2rem",
                fontWeight: "bold",
                color:
                  color === "success"
                    ? "#008060"
                    : color === "critical"
                    ? "#d82c0d"
                    : color === "warning"
                    ? "#916a00"
                    : "#202223",
              }}
            >
              {value}
            </h1>
          </div>
          {subtitle && <TextStyle variation="subdued">{subtitle}</TextStyle>}
        </div>
      </Card>
    </div>
  );

  return (
    <div style={{ marginBottom: "2rem" }}>
      <div style={{ marginBottom: "16px" }}>
        <TextStyle variation="strong">30-Day Import Overview</TextStyle>
      </div>

      <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
        <StatCard
          title="Total Imports"
          value={last_30_days.total_imports || 0}
          subtitle={`${last_30_days.successful_imports || 0} successful`}
          color="info"
        />
        <StatCard
          title="Products Processed"
          value={(last_30_days.total_products_processed || 0).toLocaleString()}
          subtitle={`${last_30_days.total_products_created ||
            0} created, ${last_30_days.total_products_updated || 0} updated`}
          color="success"
        />
        <StatCard
          title="Avg. Duration"
          value={`${last_30_days.average_duration || 0}s`}
          subtitle="per import"
          color="warning"
        />
        {(last_30_days.total_products_skipped > 0 || last_30_days.duplicate_files_skipped > 0) && (
          <StatCard
            title="Efficiency"
            value={(last_30_days.total_products_skipped || 0).toLocaleString()}
            subtitle={`products skipped (unchanged)${last_30_days.duplicate_files_skipped > 0 ? `, ${last_30_days.duplicate_files_skipped} duplicate files` : ''}`}
            color="base"
          />
        )}
      </div>

      <div
        style={{
          marginTop: "20px",
          display: "flex",
          flexWrap: "wrap",
          gap: "16px",
        }}
      >
        <div style={{ flex: "1 1 400px", minWidth: "300px" }}>
          <Card title="Impact Summary" sectioned>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "16px",
              }}
            >
              <div
                style={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span>Prices:</span>
                  <Badge status="info">{change_types.price_changes || 0}</Badge>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span>Inventory:</span>
                  <Badge status="warning">
                    {change_types.inventory_changes || 0}
                  </Badge>
                </div>
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span>Product Type:</span>
                  <Badge>{change_types.product_type_changes || 0}</Badge>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span>Promotional:</span>
                  <Badge status="success">
                    {change_types.promotional_changes || 0}
                  </Badge>
                </div>
              </div>
            </div>
          </Card>
        </div>

        <div style={{ flex: "1 1 400px", minWidth: "300px" }}>
          <Card title="Top Error Categories" sectioned>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "16px",
              }}
            >
              <div
                style={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span>CSV Parsing:</span>
                  <TextStyle variation="negative">
                    {error_types.csv_parsing || 0}
                  </TextStyle>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span>GraphQL:</span>
                  <TextStyle variation="negative">
                    {error_types.graphql_errors || 0}
                  </TextStyle>
                </div>
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span>Creation:</span>
                  <TextStyle variation="negative">
                    {error_types.product_creation || 0}
                  </TextStyle>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span>Updates:</span>
                  <TextStyle variation="negative">
                    {error_types.product_update || 0}
                  </TextStyle>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default ImportStats;
